import {Component, Input, OnInit} from '@angular/core';
import {BaseModalComponent, CompDefinition, Organization, OrganizationService} from 'brewbill-lib';
import {ModalController} from '@ionic/angular';

@Component({
    selector: 'bb-select-comp',
    templateUrl: './select-comp.component.html',
    styleUrls: ['./select-comp.component.scss'],
})
export class SelectCompComponent extends BaseModalComponent implements OnInit {
    @Input() availableComps: CompDefinition[];
    organization: Organization;

    generalComps = [];
    membershipComps = [];
    comps = [];

    compTypes = 'GENERAL';

    constructor(
        private organizationService: OrganizationService,
        modalController: ModalController
    ) {
        super(modalController);
    }

    ngOnInit() {
        this.generalComps = this.availableComps.filter(c => !c.membershipProgram);
        this.membershipComps = this.availableComps.filter(c => !!c.membershipProgram);
        this.organization = this.organizationService.currentValue;
        this.loadComps();
    }

    loadComps() {
        if (this.compTypes === 'GENERAL') {
            this.comps = this.generalComps;
        } else {
            this.comps = this.membershipComps;
        }
    }
}
